import { Link } from "@mui/material";
import { styled } from "@mui/material/styles";

interface IDownloadLink {
	url: string;
	title: string;
}

const LinkCustom = styled( Link )( (props) => ( {
	color: props.theme.palette.secondary.main,
	"&:hover": {
		color: props.theme.palette.secondary.light
	}
} ) );

export default function DownloadLink ( { url, title }: IDownloadLink ) {
	return <>
		<LinkCustom href={ url } underline="none">{ title }</LinkCustom>
	</>
}
